import React, { Component } from 'react';
import ResourceNotFound from '../components/notFound/ResourceNotFound';
import UserRegisterLandingPage from "../components/userRegistration/LandingPage";
import UserActivationLandingPage from "../components/userActivation/LandingPage";
import UserRecoverLandingPage from "../components/userRecover/LandingPage";
import { UserRegistrationContextProvider } from "../components/userRegistration/ShareStates";
import { UserActivationContextProvider } from "../components/userActivation/ShareStates";
import { UserRecoverContextProvider } from "../components/userRecover/ShareStates";

class FormView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            path: this.props.path
        }
    }

    render() {
        // console.log(this.state.path);
        let loadContent = null;
        if (this.state.path === "user/register") {
            loadContent = <UserRegisterLandingPage />
        }
        else if (this.state.path === "user/recover") {
            loadContent = <UserRecoverLandingPage />
        }
        else if (this.state.path === "user/activate") {
            loadContent = <UserActivationLandingPage />
        }
        else {
            loadContent = <ResourceNotFound />
        }
        return (
            <div>
                <React.Fragment>
                    <div id="formContainer">
                        <div id="userForm">
                            <img src="https://cdn.omax.com/web-assets/saml/omax-logo.jpg" alt="OMAX Logo"></img>
                            <div id="formContents">
                                <UserRegistrationContextProvider>
                                    <UserActivationContextProvider>
                                        <UserRecoverContextProvider>
                                            {loadContent}
                                        </UserRecoverContextProvider>
                                    </UserActivationContextProvider>
                                </UserRegistrationContextProvider>
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            </div>
        )
    }
}

export default FormView;